import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { useLazyQuery } from '@parkchirp/api-client';
import React, { useContext } from 'react';

import { CommonContext } from '../../contexts';
import { GET_AUDIT_HISTORY_CLOUD_WATCH_LINK_V2 } from '../../queries';

export interface AuditHistoryContextMenuProps {
	xrayTraceId: string;
}

export const AuditHistoryContextMenu = ({ xrayTraceId }: AuditHistoryContextMenuProps) => {
	const { AccessControlComponent, setShowSnackbar } = useContext(CommonContext);

	const [getAuditHistoryCloudWatchLink] = useLazyQuery(GET_AUDIT_HISTORY_CLOUD_WATCH_LINK_V2, {
		context: {
			apiVersion: 'v2',
		},
		fetchPolicy: 'network-only',
	});

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleCloudWatch = async () => {
		await getAuditHistoryCloudWatchLink({
			variables: { xrayTraceId },
			onError: (error) => {
				setShowSnackbar({
					message: `Could not fetch url: ${error.graphQLErrors[0].message}`,
					severity: 'error',
				});
			},
			onCompleted: (response) => {
				window.open(response.getAuditHistoryCloudWatchLink.url, '_blank');
			},
		});

		handleClose();
	};

	return (
		<AccessControlComponent componentName='AuditHistoryCloudWatchLink'>
			<IconButton sx={{ padding: 0 }} size='small' onClick={handleClick}>
				<MoreVertIcon fontSize='inherit' />
			</IconButton>
			<Menu id='long-menu' anchorEl={anchorEl} open={open} onClose={handleClose}>
				<MenuItem key='cloudWatch' onClick={handleCloudWatch}>
					View in CloudWatch
				</MenuItem>
			</Menu>
		</AccessControlComponent>
	);
};
